import PageHeader from '../PageHeader'
import BackgroundImage from '../../images/welcome-background.png'

const HeaderWelcome = () => {
    return (
        <PageHeader pageName="welcome" imageUrl={BackgroundImage}>
            <h4 className="image-text">Welcome to Be Loved Ceremonies</h4>
            <h5 className="image-text">and the homepage of</h5>
            <h1 className="image-text">Reverend Gabriela Marginean</h1>
            {/* <h3 className="image-text">Check out our collection of photos on <a className="image-text" href="https://www.instagram.com/be.loved.ceremonies/" target="_blank" rel="noreferrer noopener">the Be Loved Ceremonies Instagram</a></h3> */}
            <p className="image-text">
        <a className="image-text" href="https://www.celebrantinstitute.org/" target="_blank" rel="noreferrer noopener">Certified Lifecycle Celebrant</a>™ &
        <br />
        Ordained Minister of the <a className="image-text" href="https://www.canadianmetaphysicalministry.com/" target="_blank" rel="noreferrer noopener">Canadian International Metaphysical Ministry</a>
      </p>
            <h5 className="image-text">Our Website is Currently Under Construction. Please check back soon to see the final result!</h5>
        </PageHeader>
    )
}

export default HeaderWelcome

